import { useState, useRef, useEffect } from 'react'
import styles from './CaseDetail.module.css'
import { API_BASE_URL, getImageUrl } from '../config'

interface FormData {
  first_name: string
  last_name: string
  email: string
  phone_country_code: string
  phone: string
  company: string
  country: string
  website: string
}

interface FormErrors {
  first_name?: string
  last_name?: string
  email?: string
  phone?: string
  company?: string
  country?: string
}

export const PDF_LOCK_MARKER = '__LOCK__'

interface LockFormProps {
  isUnlocked: boolean
  onUnlock: () => void
  caseId?: number
  type?: 'case' | 'report'
  pdfDownloadUrl?: string
}

const COUNTRY_OPTIONS = [
  '新加坡',
  '中国香港',
  '马来西亚',
  '美国',
  '英国',
  '阿尔巴尼亚',
  '阿尔及利亚',
  '阿富汗',
  '阿根廷',
  '阿联酋',
  '阿曼',
  '阿塞拜疆',
  '埃及',
  '埃塞俄比亚',
  '爱尔兰',
  '爱沙尼亚',
  '安道尔',
  '安哥拉',
  '安圭拉',
  '安提瓜和巴布达',
  '奥地利',
  '澳大利亚',
  '巴巴多斯',
  '巴布亚新几内亚',
  '巴哈马',
  '巴基斯坦',
  '巴拉圭',
  '巴勒斯坦',
  '巴林',
  '巴拿马',
  '巴西',
  '白俄罗斯',
  '保加利亚',
  '北马其顿',
  '贝宁',
  '比利时',
  '冰岛',
  '波黑',
  '波兰',
  '玻利维亚',
  '伯利兹',
  '博茨瓦纳',
  '不丹',
  '布基纳法索',
  '布隆迪',
  '朝鲜',
  '赤道几内亚',
  '丹麦',
  '德国',
  '东帝汶',
  '多哥',
  '多米尼加',
  '多米尼克',
  '厄瓜多尔',
  '厄立特里亚',
  '法国',
  '梵蒂冈',
  '菲律宾',
  '斐济',
  '芬兰',
  '佛得角',
  '冈比亚',
  '刚果（布）',
  '刚果（金）',
  '哥伦比亚',
  '哥斯达黎加',
  '格林纳达',
  '格鲁吉亚',
  '古巴',
  '圭亚那',
  '哈萨克斯坦',
  '海地',
  '韩国',
  '荷兰',
  '黑山',
  '洪都拉斯',
  '基里巴斯',
  '吉布提',
  '吉尔吉斯斯坦',
  '几内亚',
  '几内亚比绍',
  '加拿大',
  '加纳',
  '加蓬',
  '柬埔寨',
  '捷克',
  '津巴布韦',
  '喀麦隆',
  '卡塔尔',
  '科摩罗',
  '科特迪瓦',
  '科威特',
  '克罗地亚',
  '肯尼亚',
  '库克群岛',
  '拉脱维亚',
  '莱索托',
  '老挝',
  '黎巴嫩',
  '立陶宛',
  '利比里亚',
  '利比亚',
  '列支敦士登',
  '卢森堡',
  '卢旺达',
  '罗马尼亚',
  '马达加斯加',
  '马尔代夫',
  '马耳他',
  '马拉维',
  '马里',
  '马绍尔群岛',
  '毛里求斯',
  '毛里塔尼亚',
  '蒙古',
  '孟加拉国',
  '秘鲁',
  '密克罗尼西亚联邦',
  '缅甸',
  '摩尔多瓦',
  '摩洛哥',
  '摩纳哥',
  '莫桑比克',
  '墨西哥',
  '纳米比亚',
  '南非',
  '南苏丹',
  '瑙鲁',
  '尼加拉瓜',
  '尼泊尔',
  '尼日尔',
  '尼日利亚',
  '纽埃',
  '挪威',
  '欧洲联盟',
  '帕劳',
  '葡萄牙',
  '日本',
  '瑞典',
  '瑞士',
  '萨尔瓦多',
  '萨摩亚',
  '塞尔维亚',
  '塞拉利昂',
  '塞内加尔',
  '塞浦路斯',
  '塞舌尔',
  '沙特阿拉伯',
  '圣多美和普林西比',
  '圣基茨和尼维斯',
  '圣卢西亚',
  '圣马力诺',
  '圣文森特和格林纳丁斯',
  '斯里兰卡',
  '斯洛伐克',
  '斯洛文尼亚',
  '斯威士兰',
  '苏丹',
  '苏里南',
  '所罗门群岛',
  '索马里',
  '塔吉克斯坦',
  '泰国',
  '坦桑尼亚',
  '汤加',
  '特立尼达和多巴哥',
  '突尼斯',
  '图瓦卢',
  '土耳其',
  '土库曼斯坦',
  '瓦努阿图',
  '危地马拉',
  '委内瑞拉',
  '文莱',
  '乌干达',
  '乌克兰',
  '乌拉圭',
  '乌兹别克斯坦',
  '西班牙',
  '希腊',
  '新西兰',
  '匈牙利',
  '叙利亚',
  '牙买加',
  '亚美尼亚',
  '也门',
  '伊拉克',
  '伊朗',
  '以色列',
  '意大利',
  '印度',
  '印度尼西亚',
  '约旦',
  '越南',
  '赞比亚',
  '乍得',
  '智利',
  '中非',
  '中国澳门',
  '中国内地',
  '中国台湾',
]

const PHONE_COUNTRY_CODES = [
  { code: '+86', label: '中国 (+86)' },
  { code: '+852', label: '中国香港 (+852)' },
  { code: '+853', label: '中国澳门 (+853)' },
  { code: '+886', label: '中国台湾 (+886)' },
  { code: '+65', label: '新加坡 (+65)' },
  { code: '+60', label: '马来西亚 (+60)' },
  { code: '+1', label: '美国 (+1)' },
  { code: '+44', label: '英国 (+44)' },
  { code: '+355', label: '阿尔巴尼亚 (+355)' },
  { code: '+213', label: '阿尔及利亚 (+213)' },
  { code: '+54', label: '阿根廷 (+54)' },
  { code: '+971', label: '阿拉伯联合酋长国 (+971)' },
  { code: '+297', label: '阿鲁巴 (+297)' },
  { code: '+968', label: '阿曼 (+968)' },
  { code: '+994', label: '阿塞拜疆 (+994)' },
  { code: '+20', label: '埃及 (+20)' },
  { code: '+251', label: '埃塞俄比亚 (+251)' },
  { code: '+353', label: '爱尔兰 (+353)' },
  { code: '+372', label: '爱沙尼亚 (+372)' },
  { code: '+376', label: '安道尔 (+376)' },
  { code: '+244', label: '安哥拉 (+244)' },
  { code: '+1-264', label: '安圭拉 (+1-264)' },
  { code: '+1-268', label: '安提瓜和巴布达 (+1-268)' },
  { code: '+43', label: '奥地利 (+43)' },
  { code: '+61', label: '澳大利亚 (+61)' },
  { code: '+1-246', label: '巴巴多斯 (+1-246)' },
  { code: '+675', label: '巴布亚新几内亚 (+675)' },
  { code: '+1-242', label: '巴哈马 (+1-242)' },
  { code: '+92', label: '巴基斯坦 (+92)' },
  { code: '+595', label: '巴拉圭 (+595)' },
  { code: '+970', label: '巴勒斯坦 (+970)' },
  { code: '+973', label: '巴林 (+973)' },
  { code: '+507', label: '巴拿马 (+507)' },
  { code: '+55', label: '巴西 (+55)' },
  { code: '+375', label: '白俄罗斯 (+375)' },
  { code: '+1-441', label: '百慕大 (+1-441)' },
  { code: '+359', label: '保加利亚 (+359)' },
  { code: '+850', label: '北朝鲜 (+850)' },
  { code: '+1-670', label: '北马里亚纳群岛 (+1-670)' },
  { code: '+229', label: '贝宁 (+229)' },
  { code: '+32', label: '比利时 (+32)' },
  { code: '+354', label: '冰岛 (+354)' },
  { code: '+1-787', label: '波多黎各 (+1-787)' },
  { code: '+48', label: '波兰 (+48)' },
  { code: '+387', label: '波斯尼亚和黑塞哥维那 (+387)' },
  { code: '+591', label: '玻利维亚 (+591)' },
  { code: '+501', label: '伯利兹 (+501)' },
  { code: '+267', label: '博茨瓦纳 (+267)' },
  { code: '+975', label: '不丹 (+975)' },
  { code: '+226', label: '布基纳法索 (+226)' },
  { code: '+257', label: '布隆迪 (+257)' },
  { code: '+240', label: '赤道几内亚 (+240)' },
  { code: '+45', label: '丹麦 (+45)' },
  { code: '+49', label: '德国 (+49)' },
  { code: '+670', label: '东帝汶 (+670)' },
  { code: '+228', label: '多哥 (+228)' },
  { code: '+1-809', label: '多米尼加共和国 (+1-809)' },
  { code: '+1-767', label: '多米尼克 (+1-767)' },
  { code: '+593', label: '厄瓜多尔 (+593)' },
  { code: '+291', label: '厄立特里亚 (+291)' },
  { code: '+33', label: '法国 (+33)' },
  { code: '+298', label: '法罗群岛 (+298)' },
  { code: '+689', label: '法属波利尼西亚 (+689)' },
  { code: '+379', label: '梵蒂冈 (+379)' },
  { code: '+63', label: '菲律宾 (+63)' },
  { code: '+679', label: '斐济 (+679)' },
  { code: '+358', label: '芬兰 (+358)' },
  { code: '+238', label: '佛得角 (+238)' },
  { code: '+500', label: '福克兰群岛 (+500)' },
  { code: '+220', label: '冈比亚 (+220)' },
  { code: '+242', label: '刚果共和国 (+242)' },
  { code: '+243', label: '刚果民主共和国 (+243)' },
  { code: '+57', label: '哥伦比亚 (+57)' },
  { code: '+506', label: '哥斯达黎加 (+506)' },
  { code: '+1-473', label: '格林纳达 (+1-473)' },
  { code: '+299', label: '格陵兰 (+299)' },
  { code: '+995', label: '格鲁吉亚 (+995)' },
  { code: '+44-1481', label: '根西岛 (+44-1481)' },
  { code: '+53', label: '古巴 (+53)' },
  { code: '+1-671', label: '关岛 (+1-671)' },
  { code: '+592', label: '圭亚那 (+592)' },
  { code: '+7', label: '哈萨克斯坦 (+7)' },
  { code: '+509', label: '海地 (+509)' },
  { code: '+82', label: '韩国 (+82)' },
  { code: '+31', label: '荷兰 (+31)' },
  { code: '+599', label: '荷属西印度群岛 (+599)' },
  { code: '+382', label: '黑山 (+382)' },
  { code: '+504', label: '洪都拉斯 (+504)' },
  { code: '+686', label: '基里巴斯 (+686)' },
  { code: '+253', label: '吉布提 (+253)' },
  { code: '+996', label: '吉尔吉斯斯坦 (+996)' },
  { code: '+224', label: '几内亚 (+224)' },
  { code: '+245', label: '几内亚比绍 (+245)' },
  { code: '+1', label: '加拿大 (+1)' },
  { code: '+233', label: '加纳 (+233)' },
  { code: '+241', label: '加蓬 (+241)' },
  { code: '+855', label: '柬埔寨 (+855)' },
  { code: '+420', label: '捷克共和国 (+420)' },
  { code: '+263', label: '津巴布韦 (+263)' },
  { code: '+237', label: '喀麦隆 (+237)' },
  { code: '+974', label: '卡塔尔 (+974)' },
  { code: '+1-345', label: '开曼群岛 (+1-345)' },
  { code: '+269', label: '科摩罗 (+269)' },
  { code: '+225', label: '象牙海岸 (+225)' },
  { code: '+383', label: '科索沃 (+383)' },
  { code: '+965', label: '科威特 (+965)' },
  { code: '+385', label: '克罗地亚 (+385)' },
  { code: '+254', label: '肯尼亚 (+254)' },
  { code: '+682', label: '库克群岛 (+682)' },
  { code: '+371', label: '拉脱维亚 (+371)' },
  { code: '+266', label: '莱索托 (+266)' },
  { code: '+856', label: '老挝 (+856)' },
  { code: '+961', label: '黎巴嫩 (+961)' },
  { code: '+370', label: '立陶宛 (+370)' },
  { code: '+231', label: '利比里亚 (+231)' },
  { code: '+218', label: '利比亚 (+218)' },
  { code: '+423', label: '列支敦士登 (+423)' },
  { code: '+262', label: '留尼旺 (+262)' },
  { code: '+352', label: '卢森堡 (+352)' },
  { code: '+250', label: '卢旺达 (+250)' },
  { code: '+40', label: '罗马尼亚 (+40)' },
  { code: '+261', label: '马达加斯加 (+261)' },
  { code: '+44-1624', label: '马恩岛 (+44-1624)' },
  { code: '+960', label: '马尔代夫 (+960)' },
  { code: '+356', label: '马耳他 (+356)' },
  { code: '+265', label: '马拉维 (+265)' },
  { code: '+223', label: '马里 (+223)' },
  { code: '+389', label: '马其顿 (+389)' },
  { code: '+692', label: '马绍尔群岛 (+692)' },
  { code: '+230', label: '毛里求斯 (+230)' },
  { code: '+222', label: '毛里塔尼亚 (+222)' },
  { code: '+1-684', label: '美属萨摩亚 (+1-684)' },
  { code: '+1-340', label: '美属维尔京群岛 (+1-340)' },
  { code: '+976', label: '蒙古 (+976)' },
  { code: '+1-664', label: '蒙特塞拉特 (+1-664)' },
  { code: '+880', label: '孟加拉国 (+880)' },
  { code: '+51', label: '秘鲁 (+51)' },
  { code: '+691', label: '密克罗尼西亚 (+691)' },
  { code: '+95', label: '缅甸 (+95)' },
  { code: '+373', label: '摩尔多瓦 (+373)' },
  { code: '+212', label: '摩洛哥 (+212)' },
  { code: '+377', label: '摩纳哥 (+377)' },
  { code: '+258', label: '莫桑比克 (+258)' },
  { code: '+52', label: '墨西哥 (+52)' },
  { code: '+264', label: '纳米比亚 (+264)' },
  { code: '+27', label: '南非 (+27)' },
  { code: '+672', label: '南极洲 (+672)' },
  { code: '+211', label: '南苏丹 (+211)' },
  { code: '+674', label: '瑙鲁 (+674)' },
  { code: '+505', label: '尼加拉瓜 (+505)' },
  { code: '+977', label: '尼泊尔 (+977)' },
  { code: '+227', label: '尼日尔 (+227)' },
  { code: '+234', label: '尼日利亚 (+234)' },
  { code: '+683', label: '纽埃 (+683)' },
  { code: '+47', label: '挪威 (+47)' },
  { code: '+680', label: '帕劳 (+680)' },
  { code: '+64', label: '皮特凯恩 (+64)' },
  { code: '+351', label: '葡萄牙 (+351)' },
  { code: '+81', label: '日本 (+81)' },
  { code: '+46', label: '瑞典 (+46)' },
  { code: '+41', label: '瑞士 (+41)' },
  { code: '+503', label: '萨尔瓦多 (+503)' },
  { code: '+685', label: '萨摩亚 (+685)' },
  { code: '+381', label: '塞尔维亚 (+381)' },
  { code: '+232', label: '塞拉利昂 (+232)' },
  { code: '+221', label: '塞内加尔 (+221)' },
  { code: '+357', label: '塞浦路斯 (+357)' },
  { code: '+248', label: '塞舌尔 (+248)' },
  { code: '+966', label: '沙特阿拉伯 (+966)' },
  { code: '+590', label: '圣巴泰勒米岛 (+590)' },
  { code: '+508', label: '圣彼得和密克隆群岛 (+508)' },
  { code: '+239', label: '圣多美和普林西比 (+239)' },
  { code: '+290', label: '圣赫勒拿岛 (+290)' },
  { code: '+1-869', label: '圣基茨和尼维斯 (+1-869)' },
  { code: '+1-758', label: '圣卢西亚 (+1-758)' },
  { code: '+1-721', label: '圣马丁岛 (+1-721)' },
  { code: '+378', label: '圣马力诺 (+378)' },
  { code: '+1-784', label: '圣文森特和格林纳丁斯 (+1-784)' },
  { code: '+94', label: '斯里兰卡 (+94)' },
  { code: '+421', label: '斯洛伐克 (+421)' },
  { code: '+386', label: '斯洛文尼亚 (+386)' },
  { code: '+268', label: '斯威士兰 (+268)' },
  { code: '+249', label: '苏丹 (+249)' },
  { code: '+597', label: '苏里南 (+597)' },
  { code: '+677', label: '所罗门群岛 (+677)' },
  { code: '+252', label: '索马里 (+252)' },
  { code: '+992', label: '塔吉克斯坦 (+992)' },
  { code: '+66', label: '泰国 (+66)' },
  { code: '+255', label: '坦桑尼亚 (+255)' },
  { code: '+676', label: '汤加 (+676)' },
  { code: '+1-649', label: '特克斯和凯科斯群岛 (+1-649)' },
  { code: '+1-868', label: '特立尼达和多巴哥 (+1-868)' },
  { code: '+216', label: '突尼斯 (+216)' },
  { code: '+688', label: '图瓦卢 (+688)' },
  { code: '+90', label: '土耳其 (+90)' },
  { code: '+993', label: '土库曼斯坦 (+993)' },
  { code: '+690', label: '托克劳 (+690)' },
  { code: '+681', label: '瓦利斯和富图纳群岛 (+681)' },
  { code: '+678', label: '瓦努阿图 (+678)' },
  { code: '+502', label: '危地马拉 (+502)' },
  { code: '+58', label: '委内瑞拉 (+58)' },
  { code: '+673', label: '文莱 (+673)' },
  { code: '+256', label: '乌干达 (+256)' },
  { code: '+380', label: '乌克兰 (+380)' },
  { code: '+598', label: '乌拉圭 (+598)' },
  { code: '+998', label: '乌兹别克斯坦 (+998)' },
  { code: '+34', label: '西班牙 (+34)' },
  { code: '+30', label: '希腊 (+30)' },
  { code: '+687', label: '新喀里多尼亚 (+687)' },
  { code: '+64', label: '新西兰 (+64)' },
  { code: '+36', label: '匈牙利 (+36)' },
  { code: '+1-876', label: '牙买加 (+1-876)' },
  { code: '+374', label: '亚美尼亚 (+374)' },
  { code: '+967', label: '也门 (+967)' },
  { code: '+98', label: '伊朗 (+98)' },
  { code: '+39', label: '意大利 (+39)' },
  { code: '+91', label: '印度 (+91)' },
  { code: '+62', label: '印度尼西亚 (+62)' },
  { code: '+1-284', label: '英属维尔京群岛 (+1-284)' },
  { code: '+246', label: '英属印度洋领地 (+246)' },
  { code: '+962', label: '约旦 (+962)' },
  { code: '+84', label: '越南 (+84)' },
  { code: '+260', label: '赞比亚 (+260)' },
  { code: '+44-1534', label: '泽西岛 (+44-1534)' },
  { code: '+235', label: '乍得 (+235)' },
  { code: '+350', label: '直布罗陀 (+350)' },
  { code: '+56', label: '智利 (+56)' },
  { code: '+236', label: '中非共和国 (+236)' },
]

const validateEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return emailRegex.test(email)
}

interface CustomSelectProps {
  options: { code: string; label: string }[] | string[]
  value: string
  onChange: (value: string) => void
  placeholder?: string
  hasError?: boolean
  className?: string
  searchable?: boolean
}

const CustomSelect = ({ options, value, onChange, placeholder, hasError, className, searchable }: CustomSelectProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [search, setSearch] = useState('')
  const containerRef = useRef<HTMLDivElement>(null)
  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(e.target as Node)) {
        setIsOpen(false)
        setSearch('')
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  useEffect(() => {
    if (isOpen && searchable && inputRef.current) {
      inputRef.current.focus()
    }
  }, [isOpen, searchable])

  useEffect(() => {
    if (!isOpen) setSearch('')
  }, [isOpen])

  const filteredOptions = searchable && search
    ? options.filter(opt => {
        const label = typeof opt === 'string' ? opt : opt.label
        return label.toLowerCase().includes(search.toLowerCase())
      })
    : options

  const selectedLabel = (): string => {
    if (!value) return placeholder || '请选择'
    if (typeof options[0] === 'string') return value
    const found = (options as { code: string; label: string }[]).find(o => o.code === value)
    return found ? found.label : value
  }

  const handleSelect = (opt: string | { code: string; label: string }) => {
    const val = typeof opt === 'string' ? opt : opt.code
    onChange(val)
    setIsOpen(false)
    setSearch('')
  }

  return (
    <div className={`${styles.customSelectWrapper} ${className || ''}`} ref={containerRef}>
      <div
        className={`${styles.input} ${styles.select} ${isOpen ? styles.customSelectOpen : ''} ${hasError ? styles.inputError : ''}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className={value ? styles.customSelectValue : styles.customSelectPlaceholder}>
          {selectedLabel()}
        </span>
      </div>
      {isOpen && (
        <div className={styles.customSelectDropdown}>
          {searchable && (
            <div className={styles.customSelectSearch}>
              <input
                ref={inputRef}
                type="text"
                className={styles.customSelectSearchInput}
                placeholder="搜索..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                onClick={(e) => e.stopPropagation()}
              />
            </div>
          )}
          <div className={styles.customSelectOptions}>
            {filteredOptions.map((opt) => {
              const label = typeof opt === 'string' ? opt : opt.label
              const optValue = typeof opt === 'string' ? opt : opt.code
              return (
                <div
                  key={optValue}
                  className={`${styles.customSelectOption} ${optValue === value ? styles.customSelectOptionSelected : ''}`}
                  onClick={() => handleSelect(opt)}
                >
                  {label}
                </div>
              )
            })}
            {filteredOptions.length === 0 && (
              <div className={styles.customSelectEmpty}>无匹配结果</div>
            )}
          </div>
        </div>
      )}
    </div>
  )
}

const LockForm = ({ onUnlock, caseId, type = 'case', pdfDownloadUrl }: LockFormProps) => {
  const [formData, setFormData] = useState<FormData>({
    first_name: '',
    last_name: '',
    email: '',
    phone_country_code: '+86',
    phone: '',
    company: '',
    country: '',
    website: '',
  })
  const [formErrors, setFormErrors] = useState<FormErrors>({})
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [submitted, setSubmitted] = useState(false)
  const [privacyAgreed, setPrivacyAgreed] = useState(false)

  const handleInputChange = (field: keyof FormData, value: string) => {
    setFormData(prev => ({ ...prev, [field]: value }))
    if (field in formErrors) {
      setFormErrors(prev => ({ ...prev, [field]: undefined }))
    }
  }

  const handleSubmit = async () => {
    const errors: FormErrors = {}

    if (!formData.first_name.trim()) {
      errors.first_name = '请输入名字'
    }
    if (!formData.last_name.trim()) {
      errors.last_name = '请输入姓氏'
    }
    if (!formData.email.trim()) {
      errors.email = '请输入邮箱'
    } else if (!validateEmail(formData.email)) {
      errors.email = '请输入正确的邮箱格式'
    }
    if (!formData.phone.trim()) {
      errors.phone = '请输入办公电话'
    }
    if (!formData.company.trim()) {
      errors.company = '请输入公司名称'
    }
    if (!formData.country) {
      errors.country = '请选择国家/地区'
    }

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors)
      return
    }

    if (!caseId) {
      console.error('Missing caseId')
      return
    }

    setIsSubmitting(true)

    try {
      const endpoint = type === 'report'
        ? `${API_BASE_URL}/api/leads/payment-reports/${caseId}`
        : `${API_BASE_URL}/api/leads/cases/${caseId}`

      const fullPhone = formData.phone_country_code + ' ' + formData.phone.trim()

      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          first_name: formData.first_name.trim(),
          last_name: formData.last_name.trim(),
          email: formData.email.trim(),
          phone: fullPhone,
          company: formData.company.trim(),
          country: formData.country,
          website: formData.website.trim(),
        })
      })

      const result = await response.json()

      if (result.success) {
        setSubmitted(true)
        onUnlock()
      } else {
        alert(result.error || '提交失败')
      }
    } catch (error) {
      console.error('Submit error:', error)
      alert('网络错误，请重试')
    } finally {
      setIsSubmitting(false)
    }
  }

  if (submitted) {
    return (
      <div className={type === 'case' ? styles.formCardCase : styles.formCard} id="form-section">
        <div className={styles.avatarWrapper}>
          <img src={getImageUrl('https://dlsy.space/suo.png')} alt="头像" className={styles.avatar} />
        </div>
        <h2 className={styles.successTitle}>提交成功！</h2>
        {pdfDownloadUrl && (
          <a
            href={pdfDownloadUrl}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.downloadLink}
          >
            <span className={styles.downloadLinkBlue}>{`点击＞> `}</span>
            <span className={styles.downloadLinkDark}>
              {type === 'report' ? '下载完整版报告' : '下载完整版案例'}
            </span>
          </a>
        )}
        <button
          className={styles.ctaButton}
          onClick={() => {
            document.getElementById('form-section')?.scrollIntoView({ behavior: 'smooth' })
          }}
        >
          扫码联系支付专家，获取更多专业解读
        </button>
        <img
          src="https://pub-47fd292248a048499531e694fc6ebedd.r2.dev/Frame-2117131402.webp"
          alt="二维码"
          className={styles.qrImage}
        />
      </div>
    )
  }

  return (
    <div className={type === 'case' ? styles.formCardCase : styles.formCard} id="form-section">
      <div className={styles.avatarWrapper}>
        <img src={getImageUrl('https://dlsy.space/suo.png')} alt="头像" className={styles.avatar} />
      </div>
      <h2 className={styles.formTitle}>填写信息解锁完整内容</h2>
      <p className={styles.formSubtitle}>请填写真实信息，以便我们的支付专家为您提供专属服务。</p>

      {/* 名字 */}
      <div className={styles.formGroup}>
        <label className={styles.label}>名字*</label>
        <input
          type="text"
          className={`${styles.input} ${formErrors.first_name ? styles.inputError : ''}`}
          placeholder="请输入您的名字"
          value={formData.first_name}
          onChange={(e) => handleInputChange('first_name', e.target.value)}
        />
        {formErrors.first_name && <span className={styles.errorText}>{formErrors.first_name}</span>}
      </div>

      {/* 姓氏 */}
      <div className={styles.formGroup}>
        <label className={styles.label}>姓氏*</label>
        <input
          type="text"
          className={`${styles.input} ${formErrors.last_name ? styles.inputError : ''}`}
          placeholder="请输入您的姓氏"
          value={formData.last_name}
          onChange={(e) => handleInputChange('last_name', e.target.value)}
        />
        {formErrors.last_name && <span className={styles.errorText}>{formErrors.last_name}</span>}
      </div>

      {/* 工作邮箱 */}
      <div className={styles.formGroup}>
        <label className={styles.label}>工作邮箱*</label>
        <input
          type="email"
          className={`${styles.input} ${formErrors.email ? styles.inputError : ''}`}
          placeholder="zhangsan@emailaddress.com"
          value={formData.email}
          onChange={(e) => handleInputChange('email', e.target.value)}
        />
        {formErrors.email && <span className={styles.errorText}>{formErrors.email}</span>}
      </div>

      {/* 办公电话 - 区号下拉 + 号码输入 */}
      <div className={styles.formGroup}>
        <label className={styles.label}>办公电话*</label>
        <div className={styles.phoneRow}>
          <CustomSelect
            options={PHONE_COUNTRY_CODES}
            value={formData.phone_country_code}
            onChange={(v) => handleInputChange('phone_country_code', v)}
            className={styles.phoneCodeSelect}
            searchable
          />
          <input
            type="tel"
            className={`${styles.input} ${styles.phoneInput} ${formErrors.phone ? styles.inputError : ''}`}
            placeholder="请输入手机号"
            value={formData.phone}
            onChange={(e) => handleInputChange('phone', e.target.value)}
          />
        </div>
        {formErrors.phone && <span className={styles.errorText}>{formErrors.phone}</span>}
      </div>

      {/* 公司名称 */}
      <div className={styles.formGroup}>
        <label className={styles.label}>公司名称*</label>
        <input
          type="text"
          className={`${styles.input} ${formErrors.company ? styles.inputError : ''}`}
          placeholder="请输入公司名称"
          value={formData.company}
          onChange={(e) => handleInputChange('company', e.target.value)}
        />
        {formErrors.company && <span className={styles.errorText}>{formErrors.company}</span>}
      </div>

      {/* 公司网址 */}
      <div className={styles.formGroup}>
        <label className={styles.label}>公司网址</label>
        <input
          type="url"
          className={styles.input}
          placeholder="www.example.com"
          value={formData.website}
          onChange={(e) => handleInputChange('website', e.target.value)}
        />
      </div>

      {/* 国家/地区 */}
      <div className={styles.formGroup}>
        <label className={styles.label}>国家/地区*</label>
        <CustomSelect
          options={COUNTRY_OPTIONS}
          value={formData.country}
          onChange={(v) => handleInputChange('country', v)}
          placeholder="请选择"
          hasError={!!formErrors.country}
          searchable
        />
        {formErrors.country && <span className={styles.errorText}>{formErrors.country}</span>}
      </div>

      {/* 隐私条款 */}
      <label className={styles.privacyCheck}>
        <input
          type="checkbox"
          checked={privacyAgreed}
          onChange={(e) => setPrivacyAgreed(e.target.checked)}
          className={styles.checkbox}
        />
        <span className={styles.privacyText}>
          我已阅读并同意
          <a
            href="https://docs.antom.com/ac/Platform/privacy"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.privacyLink}
            onClick={(e) => e.stopPropagation()}
          >
            Antom隐私政策
          </a>
          ，授权使用上述信息进行沟通和服务。
        </span>
      </label>

      <button
        className={styles.submitButton}
        onClick={handleSubmit}
        disabled={isSubmitting || !privacyAgreed}
      >
        {isSubmitting ? '提交中...' : '立即解锁完整报告'}
      </button>

      <p className={styles.agreement}>点击解锁即表示您同意接收Antom的资讯和更新</p>
    </div>
  )
}

export default LockForm
